export default () => ({
  trigger: {
    name: 'live_chat.show_icon',
    params: {},
  },
  config: {
    event: {
      name: 'show_content',
      params: {
        sub_feature: 'icon',
      },
    },
    nonInt: true,
  },
});
